import { render } from "./FeaturedCollection.vue?vue&type=template&id=4eae55c2"
import script from "./FeaturedCollection.vue?vue&type=script&lang=js"
export * from "./FeaturedCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__